// 登录保护混入
import { checkLogin } from './auth'

export const authMixin = {
  data() {
    return {
      authChecked: false
    }
  },
  mounted() {
    this.checkAuth()
  },
  created() {
    this.checkAuth()
  },
  methods: {
    checkAuth() {
      if (this.authChecked) return
      
      const auth = checkLogin()
      if (!auth.isLoggedIn) {
        this.authChecked = true
        alert('请先登录后才能使用此功能')
        
        // 尝试通过多种方式打开登录弹窗
        // 方式1：通过全局 window.$app
        if (window.$app && window.$app.openLogin) {
          window.$app.openLogin()
        }
        // 方式2：通过 $root
        else if (this.$root && this.$root.openLogin) {
          this.$root.openLogin()
        }
        // 方式3：通过 $parent
        else if (this.$parent && this.$parent.openLogin) {
          this.$parent.openLogin()
        }
        // 方式4：触发自定义事件
        else {
          this.$emit('need-login')
          // 冒泡到父组件
          if (this.$el && this.$el.dispatchEvent) {
            const event = new CustomEvent('need-login', { bubbles: true })
            this.$el.dispatchEvent(event)
          }
        }
        
        // 如果有路由，跳转到首页
        if (this.$router) {
          setTimeout(() => {
            this.$router.push('/')
          }, 1000)
        }
      }
    }
  }
}
